import React from "react";
import ServiceBody from "../MainServicePage/ServiceBody";
import { ui_ux_data } from "../ServicesDisplayPage/servicesData";

const Check_uidev = () => {
  // Pick the correct service from servicesData.js
  const service_steps = {
    data: ui_ux_data,
    title: "UI Development",
    description: "Learn UI/UX Design, User Experience, and Product Design",
    registerPath: "/Register_uiux",
  };

  return (
    <>
      <ServiceBody service_steps={service_steps} />
    </>
  );
};

export default Check_uidev;
